import { useState } from "react";
import { SiteHeader } from "../../components/header/header";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import { carsData } from "../../mock-data/car-data";
import { ItemCard } from "../../components/cards/item-card";
import { OurQualities } from "../../components/containers/qualities";
import { SiteFooter } from "../../components/footer/footer";
import { UseCarContext } from "../../services/products/product.context";
import { NavComponent } from "../../components/header/nav-component";
import { UseCartList } from "../../services/cart/cart.context";
import { CartComponent } from "../saved/cart";
import { UpdateCard } from "../../components/cards/update-delete-card";
import { AppAlert } from "../../components/utilities/alert";
import { UseAuthentication } from "../../services/authentication/authentication.context";


export const UpdateDeletePage = () => {

    const [openNav, setOpenNav] = useState(false);
    const [cartItem, setCartItem] = useState();
    const [onAlert, setOnAlert] = useState();

    const { someCars } = UseCarContext();
    const { openCart } = UseCartList();
    const { token } = UseAuthentication();
    const { carDelete } = UseCarContext();

    const navigateTo = useNavigate();

    const togglenavOpen = () => setOpenNav((st) => !st);

    const handleDelete = async (id, imagesArray, token) => {
        const resp = await carDelete(id, imagesArray, token);
        if (resp?.error) {
            setOnAlert({
                caption: 'Error!',
                message: "Deletion failed!",
                accept: "Ok",
                onAccept: () => setOnAlert()
            });
            console.log(resp);
            return;
        } else if (resp?.message) {
            setOnAlert({
                caption: 'Success!',
                message: resp?.message,
                accept: "Ok",
                onAccept: () => {
                    setOnAlert();
                    window.location.reload();
                }
            });
            return;
        } else {
            setOnAlert({
                caption: 'Uncaught Error!',
                message: 'Delete failed!',
                accept: "Ok",
                onAccept: () => setOnAlert()
            });
            return;
        }
    }

    const promptDeletion = (car) => {
        setOnAlert({
            caption: 'Delete this car?',
            message: `Do you wish to delete this ${car?.brand} ${car?.model}? This action is irreversible!`,
            accept: 'Delete',
            reject: 'Cancel',
            onAccept: async () => {
                setOnAlert();
                await handleDelete(car?._id, car?.images, token);
            },
            onReject: () => setOnAlert()
        });
        return;
    }

    return (
        <div className="f-pg app-pg">
            <SiteHeader togglenavOpen={togglenavOpen} />
            <NavComponent
                navlist={["Home", "Catalog"]}
            />
            <CartComponent
                inView={openCart}
                itemdata={cartItem}
                resetCart={() => setCartItem()}
            />
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onClose={() => setOnAlert()}
                    onAcept={onAlert.onAccept}
                    onReject={onAlert.onReject}
                />
            )}

            <div className="lg-txt hd">All Cars</div>
            <div className="car-list">
                {someCars?.map((car) => (
                    <UpdateCard
                        item={car}
                        onUpdate={() => navigateTo("/updatecar", { state: car })}
                        onDelete={() => promptDeletion(car)}
                    />
                ))}
            </div>
            <OurQualities />
            <SiteFooter />
        </div>
    )
}